/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Disable vibrations",
  "description": "Prevents the vibration and gamepad extensions from causing vibrations.",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [
    "danger"
  ],
  "enabledByDefault": false
};
export default manifest;
